import React from 'react';
import { Link } from 'react-router-dom';
import { Translate} from '../../config/TranslationProvider';
import { Marker, Popup } from 'react-leaflet';
import { getMediaUrl } from '../../api/hooks';
import { useAppConfiguration } from '../../AppConfiguration';
import { eventDate, eventDuration, extractTime, findLowestPrice } from '../../helper';
import EventProblemBadge from '../card/EventProblemBadge';
import EventDateDayRow from '../card/EventDateDayRow';

const EventMarker = ({event}) => {
    // Don't show the cheapest price if the price filter is disabled (Erlebnisregion requirement)
    const { filterConfiguration } = useAppConfiguration();
    const priceEnabled = typeof filterConfiguration.price === 'undefined' || filterConfiguration.price !== false;

    const { medialist, id, is_online_event, location, prices, title, event_dates } = event;
    const image = medialist[0];
    const start = event_dates[0].start_date;
    const end = event_dates[0].end_date;
    const eventIsCancelled = event_dates[0].is_cancelled;
    const eventIsRescheduled = event_dates[0].is_rescheduled;
    const rescheduledStartDate = event_dates[0].rescheduled_start_date;
    const rescheduledEndDate = event_dates[0].rescheduled_end_date;
    const fullDay = extractTime(start) === extractTime(end);

    return (
        <>
            {(location.lat && location.lng) &&
                <Marker position={[location.lat, location.lng]}>
                    <Popup>
                        {image && (
                            <img src={getMediaUrl(image.id, image.context, 'medium')} alt="event_image" />
                        )}

                        {eventIsCancelled && (
                            <EventProblemBadge classes="mb-4" type="cancelled" />
                        )}
                        {eventIsRescheduled && (
                            <EventProblemBadge classes="mb-4" type="rescheduled" />
                        )}

                        <h4 className="atbd_listing_title">
                            <Link to={'/events/' + id}>{title}</Link>
                        </h4>

                        {priceEnabled && (
                            <div className="atbd_listing_meta">
                                <span className="atbd_meta atbd_listing_price">
                                    {findLowestPrice(prices)}
                                </span>
                            </div>
                        )}

                        <div className="atbd_listing_data_list">
                            <ul>
                                {is_online_event && (
                                    <li>
                                        <p><span className="la la-globe" /><Translate value="online_event" /></p>
                                    </li>
                                )}
                                {!is_online_event && location.title && (
                                    <li>
                                        <p><span className="la la-building" />{location.title}</p>
                                    </li>
                                )}
                                {!is_online_event && (location.address || location.city) && (
                                    <li>
                                        <p>
                                            <span className="la la-map-marker" />
                                            {[location.address, location.city].filter(val => val).join(', ')}
                                        </p>
                                    </li>
                                )}
                                <li>
                                    <EventDateDayRow start={start} end={end} hasMoreDates={event_dates.length > 1} />
                                </li>
                                {eventIsRescheduled && (
                                    <li>
                                        <p className="rescheduled-color">
                                            <span className="la la-calendar rescheduled-color" />
                                            {rescheduledStartDate ?
                                                eventDate(rescheduledStartDate, rescheduledEndDate)
                                                :
                                                <Translate value="newDateUnknown" />
                                            }
                                            {}
                                        </p>
                                    </li>
                                )}
                                <li>
                                    <p>
                                        <span className="la la-clock-o" />
                                        {fullDay
                                            ? <Translate value="full_day" />
                                            : eventDuration(start, end)
                                        }
                                    </p>
                                </li>
                                {eventIsRescheduled && rescheduledStartDate && (
                                    <li>
                                        <p className="rescheduled-color">
                                            <span className="la la-clock-o rescheduled-color" />
                                            {fullDay
                                                ? <Translate value="full_day" />
                                                : eventDuration(rescheduledStartDate, rescheduledEndDate)
                                            }
                                        </p>
                                    </li>
                                )}
                                <li style={{paddingTop: '10px'}}>
                                    <Link to={'/events/' + id}>
                                        <Translate value="read_more" />
                                    </Link>
                                </li>
                            </ul>
                        </div>

                    </Popup>
                </Marker>
            }
        </>
    );
};

export default React.memo(EventMarker);
